/**
 * ROVITO.PL - Strona Afiliacyjna JOBOBIKE
 * Skrypt obsługujący renderowanie oferty, kody rabatowe, modale oraz zgody cookies (Consent Mode v2)
 */ 'use strict';
document.addEventListener('DOMContentLoaded', function() {
    // =========================================================================
    // 1. Google Consent Mode Helper
    // =========================================================================
    function updateGoogleConsent(analyticsGranted, marketingGranted) {
        if (typeof window.gtag === 'function') window.gtag('consent', 'update', {
            analytics_storage: analyticsGranted ? 'granted' : 'denied',
            ad_storage: marketingGranted ? 'granted' : 'denied',
            ad_user_data: marketingGranted ? 'granted' : 'denied',
            ad_personalization: marketingGranted ? 'granted' : 'denied'
        });
    }
    // =========================================================================
    // 2. Parallax Effect & Scroll Handlers
    // =========================================================================
    let isScrolling = false;
    const casettiImg = document.querySelector('.casetti-image');
    const heroContainer = document.querySelector('.hero-image-container');
    const scrollToTopBtn = document.getElementById('scrollToTop');
    window.addEventListener('scroll', function() {
        if (!isScrolling) {
            window.requestAnimationFrame(function() {
                const scrolled = window.scrollY;
                // Parallax effect in Hero section
                if (scrolled < window.innerHeight) {
                    if (casettiImg && window.innerWidth >= 1024) casettiImg.style.transform = `translateY(${scrolled * 0.15}px)`;
                    else if (casettiImg) casettiImg.style.transform = `scaleX(-1) translateY(${scrolled * 0.25}px)`;
                    if (heroContainer) heroContainer.style.transform = `translateY(${scrolled * 0.4}px)`;
                }
                // Scroll to top button visibility
                if (scrollToTopBtn) {
                    if (scrolled > 350) scrollToTopBtn.classList.add('visible');
                    else scrollToTopBtn.classList.remove('visible');
                }
                isScrolling = false;
            });
            isScrolling = true;
        }
    }, {
        passive: true
    });
    // Scroll to top click
    if (scrollToTopBtn) scrollToTopBtn.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
    // Smooth scroll CTA
    const ctaBtn = document.querySelector('.cta');
    if (ctaBtn) ctaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetSection = document.querySelector(targetId);
        if (targetSection) {
            targetSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            targetSection.classList.add('highlight-section');
            setTimeout(()=>{
                targetSection.classList.remove('highlight-section');
            }, 1500);
        }
    });
    // =========================================================================
    // 3. Coupon Code Copy
    // =========================================================================
    const copyBtn = document.getElementById('copy-btn');
    const couponEl = document.getElementById('coupon');
    const statusEl = document.getElementById('status');
    if (copyBtn && couponEl) {
        const originalLabel = copyBtn.querySelector('.copy-label') ? copyBtn.querySelector('.copy-label').textContent : 'Kopiuj';
        copyBtn.addEventListener('click', async function() {
            const code = couponEl.textContent.trim();
            let copied = false;
            if (navigator.clipboard && window.isSecureContext) try {
                await navigator.clipboard.writeText(code);
                copied = true;
            } catch (e) {
                copied = false;
            }
            // Fallback
            if (!copied) try {
                const textArea = document.createElement('textarea');
                textArea.value = code;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                copied = document.execCommand('copy');
                textArea.remove();
            } catch (e) {
                copied = false;
            }
            if (copied) {
                copyBtn.classList.add('copied');
                const copyLabel = copyBtn.querySelector('.copy-label');
                if (copyLabel) copyLabel.textContent = "Skopiowano! \u2713";
                if (statusEl) statusEl.classList.add('visible');
                setTimeout(()=>{
                    copyBtn.classList.remove('copied');
                    if (copyLabel) copyLabel.textContent = originalLabel;
                    if (statusEl) statusEl.classList.remove('visible');
                }, 3000);
            } else window.prompt('Skopiuj kod rabatowy:', code);
        });
    }
    // =========================================================================
    // 4. Bikes Catalog & Dynamic Rendering
    // =========================================================================
    const bikesList = document.querySelector('.bikes-list');
    const DISCOUNT_RATE = 0.06; // 6% discount with code CASETTI
    const FALLBACK_BIKES = [
        {
            name: 'JOBOBIKE Sam',
            description: "Sam \u2013 Sk\u0142adany rower elektryczny miejski dla senior\xf3w i kobiet. Wyr\xf3\u017Cnia si\u0119 nisk\u0105 ram\u0105, \u0142atwym sk\u0142adaniem i wspomaganiem do 25 km/h.",
            picture: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/JOBOBIKE_Sam_damski_rower_elektryczny_200x200.webp?v=1774944480',
            pictureLarge: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/JOBOBIKE_Sam_damski_rower_elektryczny_800x800.webp?v=1774944480',
            link: 'https://jobobike.pl/products/jobobike-sam',
            price: 5799,
            available: true
        },
        {
            name: 'JOBOBIKE Eddy X',
            description: 'Eddy X \u2013 Sk\u0142adany rower elektryczny typu fatbike z szerokimi oponami 20x4.0". Idealny do miasta, lasu i na pla\u017C\u0119.',
            picture: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/Rower_elektryczny_Eddy_X_do_jazdy_po_miescie_i_w_terenie_200x200.webp?v=1779155633',
            pictureLarge: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/Rower_elektryczny_Eddy_X_do_jazdy_po_miescie_i_w_terenie_800x800.webp?v=1779155633',
            link: 'https://jobobike.pl/products/jobobike-eddy-x',
            price: 5999,
            available: true
        },
        {
            name: 'JOBOBIKE Robin Pro',
            description: "Robin Pro \u2013 Fatbike elektryczny MTB z silnikiem Bafang 80 Nm i bateri\u0105 960 Wh. Zasi\u0119g nawet do 180 km na jednym \u0142adowaniu.",
            picture: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/Robin_Pro_Focus_test_200x200.webp?v=1787127738',
            pictureLarge: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/Robin_Pro_Focus_test_800x800.webp?v=1787127738',
            link: 'https://jobobike.pl/products/jobobike-robin-pro',
            price: 7399,
            available: true
        },
        {
            name: 'JOBOBIKE Transer',
            description: "Transer \u2013 Elektryczny rower transportowy cargo o du\u017Cej \u0142adowno\u015Bci. Zaprojektowany z my\u015Bl\u0105 o przewozie dzieci i wi\u0119kszych zakup\xf3w.",
            picture: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/jobobike_15Ah_Rodzinny_rower_elektryczny_do_przewozu_ladunkow_Transer_200x200.webp?v=1765174197',
            pictureLarge: 'https://cdn.shopify.com/s/files/1/0594/6893/9454/files/jobobike_15Ah_Rodzinny_rower_elektryczny_do_przewozu_ladunkow_Transer_800x800.webp?v=1765174197',
            link: 'https://jobobike.pl/products/jobobike-transer',
            price: 8999,
            available: true
        }
    ];
    function escapeHtml(str) {
        return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function formatPrice(price, currency) {
        if (price == null || Number.isNaN(Number(price))) return '';
        try {
            return new Intl.NumberFormat('pl-PL', {
                style: 'currency',
                currency: currency || 'PLN',
                maximumFractionDigits: 0
            }).format(Number(price));
        } catch (e) {
            return Number(price).toFixed(0) + " z\u0142";
        }
    }
    function renderBikes(bikes, meta) {
        if (!bikesList) return;
        bikesList.innerHTML = '';
        if (!bikes || !bikes.length) {
            bikesList.innerHTML = '<p class="bikes-empty">Brak dost\u0119pnych rower\xf3w w ofercie.</p>';
            return;
        }
        // Remove existing updated stamp if any
        const oldStamp = document.querySelector('.bikes-updated');
        if (oldStamp) oldStamp.remove();
        bikes.forEach((bike)=>{
            const card = document.createElement('article');
            card.classList.add('bike-card');
            if (bike.available === false) card.classList.add('bike-card--unavailable');
            const basePrice = bike.price != null ? Number(bike.price) : null;
            let pricingHtml = '';
            let ctaLabel = "Sprawd\u017A model";
            if (basePrice != null && !Number.isNaN(basePrice)) {
                const discountedPrice = Math.round(basePrice * (1 - DISCOUNT_RATE));
                const savings = basePrice - discountedPrice;
                ctaLabel = `Kup za ${formatPrice(discountedPrice, bike.currency)} z kodem`;
                pricingHtml = `
          <div class="bike-pricing-box">
            <div class="bike-price-header">
              <span class="bike-price-old-label">Cena regularna:</span>
              <span class="bike-price-old">${escapeHtml(formatPrice(basePrice, bike.currency))}</span>
            </div>
            <div class="bike-price-final-row">
              <span class="bike-price-label">Z kodem <strong class="code-highlight">CASETTI</strong> (-6%):</span>
              <span class="bike-price-current">${escapeHtml(formatPrice(discountedPrice, bike.currency))}</span>
            </div>
            <div class="bike-savings-pill">
              <span class="savings-icon" aria-hidden="true">\u{1F3F7}\u{FE0F}</span> Oszcz\u{119}dzasz <strong>${escapeHtml(formatPrice(savings, bike.currency))}</strong>
            </div>
          </div>
        `;
            }
            const badgeHtml = bike.available === false ? '<span class="bike-badge bike-badge--soldout">Wyprzedane</span>' : '<span class="bike-badge bike-badge--discount">-6% KOD: CASETTI</span>';
            if (bike.available === false) ctaLabel = "Zobacz specyfikacj\u0119";
            const picture = bike.picture || '';
            const large = bike.pictureLarge || (picture ? picture.replace('200x200', '800x800') : '');
            card.innerHTML = `
        ${badgeHtml}
        <div class="bike-card-image-wrapper" role="button" tabindex="0" aria-label="Powi\u{119}ksz zdj\u{119}cie modelu ${escapeHtml(bike.name)}">
          <img 
            src="${escapeHtml(picture)}" 
            alt="${escapeHtml(bike.name)}" 
            class="bike-image" 
            data-large="${escapeHtml(large)}" 
            loading="lazy"
            width="280"
            height="280"
          >
          <span class="bike-zoom-hint" aria-hidden="true">\u{1F50D} Powi\u{119}ksz</span>
        </div>
        <div class="bike-card-content">
          <h3>${escapeHtml(bike.name)}</h3>
          ${pricingHtml}
          <p>${escapeHtml(bike.description || '')}</p>
          <a href="${escapeHtml(bike.link)}" target="_blank" rel="noopener noreferrer" class="bike-cta-btn">
            ${escapeHtml(ctaLabel)} &rarr;
          </a>
        </div>
      `;
            bikesList.appendChild(card);
        });
        if (meta && meta.scrapedAt) {
            const stamp = document.createElement('p');
            stamp.className = 'bikes-updated';
            try {
                const d = new Date(meta.scrapedAt);
                stamp.textContent = 'Oferta zsynchronizowana ze sklepem JOBOBIKE: ' + d.toLocaleString('pl-PL', {
                    dateStyle: 'medium',
                    timeStyle: 'short'
                });
            } catch (e) {
                stamp.textContent = 'Oferta aktualizowana automatycznie ze sklepu JOBOBIKE.';
            }
            bikesList.parentElement && bikesList.parentElement.appendChild(stamp);
        }
    }
    async function loadBikes() {
        try {
            const res = await fetch('bikes.json', {
                cache: 'no-cache'
            });
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const data = await res.json();
            const list = Array.isArray(data.bikes) ? data.bikes : [];
            if (!list.length) throw new Error("Pusta lista rower\xf3w");
            renderBikes(list, data);
        } catch (err) {
            console.warn("Nie uda\u0142o si\u0119 wczyta\u0107 bikes.json \u2013 u\u017Cywam listy zapasowej.", err);
            renderBikes(FALLBACK_BIKES, null);
        }
    }
    loadBikes();
    // =========================================================================
    // 5. Image Modal Handling
    // =========================================================================
    const imageModal = document.getElementById('imageModal');
    const modalImg = imageModal ? imageModal.querySelector('.modal-image') : null;
    const modalSpinner = imageModal ? imageModal.querySelector('.modal-loading-spinner') : null;
    const imageModalClose = document.getElementById('imageModalClose');
    const imageModalCloseBottom = document.getElementById('imageModalCloseBottom');
    function openImageModal(imgSrc, altText) {
        if (!imageModal || !modalImg || !modalSpinner) return;
        modalImg.classList.remove('loaded');
        modalSpinner.classList.remove('hidden');
        imageModal.classList.add('active');
        imageModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        const tempImg = new Image();
        tempImg.onload = function() {
            modalImg.src = imgSrc;
            modalImg.alt = altText || "Zdj\u0119cie roweru";
            modalImg.classList.add('loaded');
            modalSpinner.classList.add('hidden');
        };
        tempImg.onerror = function() {
            modalSpinner.innerHTML = "<p>Nie uda\u0142o si\u0119 za\u0142adowa\u0107 zdj\u0119cia.</p>";
            setTimeout(closeImageModal, 2000);
        };
        tempImg.src = imgSrc;
    }
    function closeImageModal() {
        if (!imageModal) return;
        imageModal.classList.remove('active');
        imageModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }
    // Click on bike image wrapper
    if (bikesList) {
        bikesList.addEventListener('click', function(e) {
            const wrapper = e.target.closest('.bike-card-image-wrapper');
            if (wrapper) {
                const img = wrapper.querySelector('.bike-image');
                if (img) {
                    const large = img.getAttribute('data-large');
                    const src = large || img.src.replace('200x200', '800x800');
                    openImageModal(src, img.alt);
                }
            }
        });
        bikesList.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                const wrapper = e.target.closest('.bike-card-image-wrapper');
                if (wrapper) {
                    e.preventDefault();
                    const img = wrapper.querySelector('.bike-image');
                    if (img) {
                        const large = img.getAttribute('data-large');
                        const src = large || img.src.replace('200x200', '800x800');
                        openImageModal(src, img.alt);
                    }
                }
            }
        });
    }
    if (imageModalClose) imageModalClose.addEventListener('click', closeImageModal);
    if (imageModalCloseBottom) imageModalCloseBottom.addEventListener('click', closeImageModal);
    if (imageModal) imageModal.addEventListener('click', function(e) {
        if (e.target === imageModal) closeImageModal();
    });
    // =========================================================================
    // 6. Privacy Policy Modal Handling
    // =========================================================================
    const privacyModal = document.getElementById('privacyModal');
    const privacyModalBody = document.getElementById('privacyModalBody');
    const privacyModalClose = document.getElementById('privacyModalClose');
    const privacyModalCloseBottom = document.getElementById('privacyModalCloseBottom');
    const footerPrivacyLink = document.getElementById('footerPrivacyLink');
    const cookiePrivacyLink = document.getElementById('cookiePrivacyLink');
    let privacyContentCached = null;
    async function openPrivacyModal() {
        if (!privacyModal || !privacyModalBody) return;
        privacyModal.classList.add('active');
        privacyModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (privacyContentCached) {
            privacyModalBody.innerHTML = privacyContentCached;
            return;
        }
        try {
            privacyModalBody.innerHTML = "<p>\u0141adowanie polityki prywatno\u015Bci...</p>";
            const res = await fetch('privacy.html');
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const main = doc.querySelector('main');
            const content = main ? main.innerHTML : html;
            privacyContentCached = content;
            privacyModalBody.innerHTML = content;
        } catch (e) {
            privacyModalBody.innerHTML = '<p>Nie uda\u0142o si\u0119 za\u0142adowa\u0107 tre\u015Bci. Mo\u017Cesz otworzy\u0107 pe\u0142ny dokument pod adresem <a href="privacy.html" target="_blank">privacy.html</a>.</p>';
        }
    }
    function closePrivacyModal() {
        if (!privacyModal) return;
        privacyModal.classList.remove('active');
        privacyModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }
    if (footerPrivacyLink) footerPrivacyLink.addEventListener('click', function(e) {
        e.preventDefault();
        openPrivacyModal();
    });
    if (cookiePrivacyLink) cookiePrivacyLink.addEventListener('click', function(e) {
        e.preventDefault();
        openPrivacyModal();
    });
    if (privacyModalClose) privacyModalClose.addEventListener('click', closePrivacyModal);
    if (privacyModalCloseBottom) privacyModalCloseBottom.addEventListener('click', closePrivacyModal);
    if (privacyModal) privacyModal.addEventListener('click', function(e) {
        if (e.target === privacyModal) closePrivacyModal();
    });
    // Global ESC key to close any active modal
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            if (imageModal && imageModal.classList.contains('active')) closeImageModal();
            if (privacyModal && privacyModal.classList.contains('active')) closePrivacyModal();
        }
    });
    // =========================================================================
    // 7. Cookie Consent & Management (RODO / Google Consent Mode v2)
    // =========================================================================
    const COOKIE_KEY = 'jobobike_cookie_consent_v1';
    const COOKIE_EXPIRY_MONTHS = 12;
    const cookieModal = document.getElementById('cookieModal');
    const cookieAcceptAll = document.querySelector('.cookie-accept-all');
    const cookieReject = document.querySelector('.cookie-reject');
    const cookieSettingsToggle = document.querySelector('.cookie-settings-toggle');
    const cookieSettingsPane = document.getElementById('cookieSettingsPane');
    const cookieSavePrefs = document.querySelector('.cookie-save-preferences');
    const cookieCancelPrefs = document.querySelector('.cookie-cancel-settings');
    const cookieOptAnalytics = document.getElementById('cookieOptAnalytics');
    const cookieOptMarketing = document.getElementById('cookieOptMarketing');
    const cookieManageBtn = document.getElementById('cookieManageBtn');
    function readStoredConsent() {
        try {
            const raw = localStorage.getItem(COOKIE_KEY);
            if (!raw) return null;
            const data = JSON.parse(raw);
            if (!data || !data.timestamp) return null;
            const savedDate = new Date(data.timestamp);
            if (Number.isNaN(savedDate.getTime())) return null;
            const expiryDate = new Date(savedDate);
            expiryDate.setMonth(expiryDate.getMonth() + COOKIE_EXPIRY_MONTHS);
            if (new Date() >= expiryDate) {
                localStorage.removeItem(COOKIE_KEY);
                return null;
            }
            return data;
        } catch (e) {
            return null;
        }
    }
    function saveStoredConsent(consent) {
        try {
            consent.timestamp = new Date().toISOString();
            localStorage.setItem(COOKIE_KEY, JSON.stringify(consent));
            updateGoogleConsent(consent.analytics, consent.marketing);
        } catch (e) {
            console.warn("Nie mo\u017Cna zapisa\u0107 zgody w localStorage", e);
        }
    }
    function showCookieBanner() {
        if (!cookieModal) return;
        cookieModal.removeAttribute('hidden');
        cookieModal.setAttribute('aria-hidden', 'false');
    }
    function hideCookieBanner() {
        if (!cookieModal) return;
        cookieModal.setAttribute('hidden', '');
        cookieModal.setAttribute('aria-hidden', 'true');
    }
    // Check initial consent state
    const currentConsent = readStoredConsent();
    if (!currentConsent) setTimeout(showCookieBanner, 600);
    else {
        // Apply previously saved consents to GTM
        updateGoogleConsent(currentConsent.analytics, currentConsent.marketing);
        if (cookieOptAnalytics) cookieOptAnalytics.checked = !!currentConsent.analytics;
        if (cookieOptMarketing) cookieOptMarketing.checked = !!currentConsent.marketing;
    }
    if (cookieAcceptAll) cookieAcceptAll.addEventListener('click', function() {
        saveStoredConsent({
            necessary: true,
            analytics: true,
            marketing: true
        });
        hideCookieBanner();
    });
    if (cookieReject) cookieReject.addEventListener('click', function() {
        saveStoredConsent({
            necessary: true,
            analytics: false,
            marketing: false
        });
        hideCookieBanner();
    });
    if (cookieSettingsToggle) cookieSettingsToggle.addEventListener('click', function() {
        if (!cookieSettingsPane) return;
        const isHidden = cookieSettingsPane.hasAttribute('hidden');
        if (isHidden) cookieSettingsPane.removeAttribute('hidden');
        else cookieSettingsPane.setAttribute('hidden', '');
    });
    if (cookieSavePrefs) cookieSavePrefs.addEventListener('click', function() {
        const analytics = !!(cookieOptAnalytics && cookieOptAnalytics.checked);
        const marketing = !!(cookieOptMarketing && cookieOptMarketing.checked);
        saveStoredConsent({
            necessary: true,
            analytics,
            marketing
        });
        hideCookieBanner();
    });
    if (cookieCancelPrefs) cookieCancelPrefs.addEventListener('click', function() {
        if (cookieSettingsPane) cookieSettingsPane.setAttribute('hidden', '');
    });
    if (cookieManageBtn) cookieManageBtn.addEventListener('click', function() {
        const saved = readStoredConsent();
        if (cookieOptAnalytics) cookieOptAnalytics.checked = !!(saved && saved.analytics);
        if (cookieOptMarketing) cookieOptMarketing.checked = !!(saved && saved.marketing);
        if (cookieSettingsPane) cookieSettingsPane.removeAttribute('hidden');
        showCookieBanner();
    });
});

//# sourceMappingURL=rovito.b0187b57.js.map
